var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegrationPrimaryDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 17.52,
    viewBox: "0 0 17.5 17.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Integration_Hover",
    "data-name": "Integration Hover",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intergration",
    d: "M13.69,11.88h1.09a1.89,1.89,0,1,0,.04-3.78H13.68a.079.079,0,0,1-.08-.08h0V5.07a1.477,1.477,0,0,0-1.48-1.48H9.18s-.08-.03-.08-.08h0V2.45A1.913,1.913,0,0,0,7.25.53,1.887,1.887,0,0,0,5.33,2.38V3.5s-.03.08-.08.08H2.3A1.515,1.515,0,0,0,.79,5.09V7.77s.03.08.08.08H1.9a2.137,2.137,0,0,1,.03,4.27H.87s-.08.03-.08.08h0v2.68A1.515,1.515,0,0,0,2.3,16.39H4.98s.08-.03.08-.08v-.8a2.189,2.189,0,0,1,2.1-2.18,2.016,2.016,0,0,1,2.17,1.85V16.3s.03.08.08.08h2.71A1.477,1.477,0,0,0,13.6,14.9V11.92s.03-.08.08-.08",
    fill: "#adc7ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_152",
    cx: 0.41,
    cy: 0.41,
    r: 0.41,
    transform: "translate(14.8 6)",
    fill: "#165cf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M8.68,3.93h5v5h0a5,5,0,0,1-5-5h0Z",
    fill: "#f49b31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intergration-2",
    d: "M12.18,3.83H9.21s-.08-.03-.08-.08h0V2.69A1.928,1.928,0,0,0,7.26.75,1.908,1.908,0,0,0,5.32,2.62V3.75s-.03.08-.08.08H2.27A1.519,1.519,0,0,0,.75,5.35V8.06s.03.08.08.08H1.86a2.157,2.157,0,0,1,.03,4.31H.83s-.08.03-.08.08v2.71a1.519,1.519,0,0,0,1.52,1.52H4.98s.08-.03.08-.08v-.8a2.2,2.2,0,0,1,2.12-2.19,2.038,2.038,0,0,1,2.19,1.87v1.13s.03.08.08.08h2.74a1.494,1.494,0,0,0,1.49-1.49v-3s.03-.08.08-.08h1.1a1.905,1.905,0,1,0-.03-3.81H13.76",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intergration-3",
    d: "M13.67,5.32a1.494,1.494,0,0,0-1.49-1.49",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationPrimaryDarkIcon);
export default __webpack_public_path__ + "static/media/integration-primary-dark-icon.0126ba681e1b56567d44e96c85f43ee7.svg";
export { ForwardRef as ReactComponent };